import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faEdit,
  faDownload,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Residence from "../Components/Residence";
import { FaPlusCircle, FaUpload, FaDownload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Residences() {
  const { state } = useContext(AuthContext);
  const [residences, setResidences] = useState([]);
  const [url, setUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/accountResidences/${state.account}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setResidences(response.data.residences);
      setIsLoading(false);
    }
    fetch();
  }, [state.account, state.token]);

  const handleDownloadAccountResidences = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/residences/download/information/${state.account}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setUrl(response.data.url);
    setIsLoading(false);
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="residences">
        <Col className="residences-header">
          <Row className="align-items-center">
            <Col lg={10} className="mb-3">
              <h4>Residencias</h4>
            </Col>
            {state.role === "root" ? (
              <Col lg={2} className="right mb-3">
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    style={{
                      backgroundColor: "#03acbe",
                      borderColor: "#03acbe",
                    }}
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => handleDownloadAccountResidences()}
                    >
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{ color: "#555", marginRight: 5 }}
                      />
                      Descargar residentes
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to={"/new-residence"}>
                      <FontAwesomeIcon
                        icon={faPlus}
                        style={{ color: "#555", marginRight: 5 }}
                      />
                      Nueva residencia
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            ) : (
              <Col lg={2} className="right icon">
                <FaPlusCircle onClick={() => navigate("/new-residence")} />
              </Col>
            )}
          </Row>
          {url === "" ? (
            <></>
          ) : (
            <Row>
              <Col className="mb-3">
                <Alert variant="success">
                  Tu reporte ha sido generado con éxito.{" "}
                  <Alert.Link href={url}>Descargar reporte.</Alert.Link>.
                </Alert>
              </Col>
            </Row>
          )}
        </Col>
        <Col className="residences-content">
          {residences.map((item) => (
            <Residence address={item.address} id={item._id} key={item._id} />
          ))}
        </Col>
      </Col>
    );
  }
}

export default Residences;
